<div class="p-2 tw-flex tw-justify-around bottom-sort-filters">

  <app-car-city-popup></app-car-city-popup>

  <app-car-sort-popup></app-car-sort-popup>

  <app-car-filter-popup (applyFilterEvent)="onApplyFilters($event)"></app-car-filter-popup>

  <app-car-shortlist-popup></app-car-shortlist-popup>

</div>